import React from "react"

export type TBlobContextItem = {
  id: string
  blob: Blob
  fileUrl?: string
}

export const BlobContext = React.createContext({
  blobList: [] as Array<TBlobContextItem>,
  addBlobItem: (newItem: TBlobContextItem): void => {},
  removeBlobItem: (targetId: string): void => {},
})

/**
 * 乗務員マスタのProvider
 */
export const ZyomuinMasterRegisterProvider: React.FC<{
  blobList: Array<TBlobContextItem>
  addBlobItem: (newItem: TBlobContextItem) => void
  removeBlobItem: (targetId: string) => void
}> = (props) => {
  return (
    <BlobContext.Provider
      value={{
        blobList: props.blobList,
        addBlobItem: props.addBlobItem,
        removeBlobItem: props.removeBlobItem,
      }}>
      {props.children}
    </BlobContext.Provider>
  )
}
